export const crmApi = require("./crm").default;
export const orgApi = require("./org").default;
export const salesApi = require("./sales").default;
export const researchApi = require("./research").default;
export const permissionsApi = require("./permissions").default;
export const materialApi = require("./wl").default;
export const personnelApi = require("./personnel").default;
export const deviceApi = require("./device").default;
export const generalApi = require("./general").default;
export const configDataApi = require("./init").default;
export const costApi = require("./cost").default;
export const fundsApi = require("./funds").default;
export const procurementApi = require("./procurement").default;
export const engineeringApi = require("./engineering").default;
export const productionApi = require("./production").default;
